import React from 'react';
import { GrDeliver } from 'react-icons/gr'
import { GiCigar } from 'react-icons/gi'


export const infoSection = [
    {
        heading: 'Easy to Order',
        paragraph: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.',
        icon: <GrDeliver />,
    },
    {
        heading: 'Easy to Order',
        paragraph: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic.',
        icon: <GrDeliver />,
    },
    {
        heading: 'Доказано качество',
        paragraph: 'В Corojo Club може да намерите само оригинални продукти.',
        icon: <GiCigar />,
    },

]